export const addEntityToCache = (cache, field, entity) => {
  cache.modify({
    fields: {
      [field](existing = []) {
        return [entity, ...existing];
      }
    }
  });
};

export const removeEntityFromCache = (cache, field, entityId) => {
  cache.modify({
    fields: {
      [field](existing = [], { readField }) {
        return existing.filter(docRef => readField('Id', docRef) !== entityId);
      }
    }
  });
};
